import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import { TRANSPORT_AVAILABILITY_STATUS } from 'api/query-keys.ts';
import type { TTransportAvailabilityStatusRes } from 'api/swagger';

interface IParams {
  enabled: boolean;
}

export const useGetTransportAvailabilityStatus = (transportId: number, params: IParams) => {
  const { enabled } = params;
  return useQuery<TTransportAvailabilityStatusRes>({
    queryKey: [TRANSPORT_AVAILABILITY_STATUS, transportId],
    queryFn: async () => {
      const { data } = await http.get<TTransportAvailabilityStatusRes>(`/v1/transports/${transportId}/occupancy`);
      return data;
    },
    retry: false,
    refetchOnWindowFocus: false,
    enabled,
  });
};
